import { uniqueId }     from "lodash";
import { Modal }        from "./Modal";
import { ModalProps }   from "./Modal";
import useWillMount     from "@widesk-core/hooks/useWillMount";
import ModalStore       from "@widesk-ui/stores/modalStore";
import globalModalStore from "@widesk-ui/stores/globalModalStore";

export function FormModal(props: ModalProps & { formId?: string }) {
	const modalStore = useWillMount(() => new ModalStore({
		...props,
		formId: props.formId || uniqueId(),
	}));
	
	return (
		<Modal 
			okButtonProps={{ 
				htmlType: 'submit',
				form: modalStore.props.formId,
			}}
			modalStore={modalStore}
			{...props} 
		/>
	);
}

FormModal.open = globalModalStore.addModal;

FormModal.openAsync = globalModalStore.addModalAsync;

FormModal.close = globalModalStore.removeLastModal;
